import { cacheDom } from "../utils/QuerySelectors.js"
import { setupPaginations } from '../components/Pagination.js'

const state = {
  filterOpened: false,
  sortOpened: false,
}
const dom = {}
const qs = {
  facetsContainer: 'data-facets-container',
  productsGrid: 'data-products-grid',
  filterSortContainer: 'data-plp-filter-sort',
  filterContainer: 'data-plp-filter',
  sortContainer: 'data-plp-sort',
  filterBtn: 'data-plp-filter-btn',
  sortBtn: 'data-plp-sort-btn',
  plpPaginator: 'data-plp-paginator',
  plpTypesFilter: 'data-plp-types-filter',
  count: 'data-plp-count',
  // tagFilterBtn: 'data-tag-filter',
}
const qsAll = {
  facets: 'data-facet',
  facetRemoves: 'data-facet-remove',
  clearFacets: 'data-clear',
  filterChild: 'data-filter-child',
  sortOptions: 'name="sort_by"',
  // inlineTypeFilters: 'data-inline-type-filter',
  mobileFilterSortCloses: 'data-mobile-filtersort-close',
}

const openFilterSort = () => {
  if(window.innerWidth >= 1024) {
    // Adjust classes for enabling desktop panel
    dom.filterSortContainer.classList.add('!w-[20.5rem]', '!overflow-auto')
    dom.plpPaginator.classList.add('w-[calc(100%-21.5rem)]')
    dom.plpPaginator.classList.remove('w-full')
    dom.productsGrid.classList.add('gap-x-4')

    // Adjust classes for disabling mobile panel
    dom.filterSortContainer.classList.remove('block', '!w-full')
    dom.filterSortContainer.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  } else {
    // Adjust classes for disabling desktop panel
    dom.filterSortContainer.classList.remove('!w-[20.5rem]', '!overflow-auto')
    dom.plpPaginator.classList.remove('w-[calc(100%-21.5rem)]')
    dom.plpPaginator.classList.add('w-full')
    dom.productsGrid.classList.remove('gap-x-4')

    // Adjust classes for enabling mobile panel
    dom.filterSortContainer.classList.add('block', '!w-full')
    dom.filterSortContainer.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }
}

const closeFilterSort = () => {
  // Adjust classes for disabling desktop panel
  dom.filterSortContainer.classList.remove('!w-[20.5rem]', '!overflow-auto')
  dom.plpPaginator.classList.remove('w-[calc(100%-21.5rem)]')
  dom.plpPaginator.classList.add('w-full')
  dom.productsGrid.classList.remove('gap-x-4')

  // Adjust classes for disabling mobile panel
  dom.filterSortContainer.classList.remove('block', '!w-full')
  dom.filterSortContainer.classList.add('hidden')
  document.body.classList.remove('overflow-hidden')
}

const initFilterFacets = (openedFilterIndexes=[]) => {
  dom.facets.forEach((facet) => {
    facet.addEventListener('input', () => {
      renderFilterResults()
    })
  })
  
  dom.clearFacets.forEach((clearBtn) => {
    clearBtn.addEventListener('click', (e) => {
      const removeUrl = e.target.dataset.url
      fetchResults(removeUrl)
    })
  })
  dom.facetRemoves.forEach((facetRemove) => {
    facetRemove.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      
      const removeUrl = `${facetRemove.href}&section_id=${dom.facetsContainer.dataset.sectionId}`
      fetchResults(removeUrl)
    })
  })
  if(openedFilterIndexes.length > 0) {
    dom.facetsContainer.querySelectorAll(`[${qsAll.filterChild}]`).forEach((child, index) => {
      if(openedFilterIndexes.includes(index)) child.querySelector('details').setAttribute('open', '')
    })
  }

  if(state.filterOpened) {
    openFilterSort()
    dom.filterContainer.classList.add('!flex')
  }
  if(state.sortOpened) {
    openFilterSort()
    dom.sortContainer.classList.add('!block')
  }

  dom.sortOptions.forEach((sortOption) => {
    sortOption.addEventListener('input', () => {
      renderFilterResults()
    })
  })

  dom.filterSortContainer.querySelectorAll('summary').forEach((summary) => {
    summary.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })

  // dom.inlineTypeFilters.forEach((typeFilter) => {
  //   typeFilter.addEventListener('click', (e) => {
  //     e.target.classList.toggle('button--active')
  //     const filterOption = document.querySelector(`[name="${e.target.dataset.filterName}"][value="${e.target.dataset.value}"]`)
  //     if(filterOption) {
  //       filterOption.checked = e.target.classList.contains('button--active')
  //       renderFilterResults()
  //     }
  //   })
  // })
  dom.mobileFilterSortCloses.forEach((mobileFilterSortClose) => {
    mobileFilterSortClose.addEventListener('click', (e) => {
      closeFilterSort()
      state.filterOpened = false
      state.sortOpened = false
      dom.sortBtn.classList.remove('!underline')
      dom.filterBtn.classList.remove('!underline')
    })
  })
}

const fetchResults = (url) => {
  fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      dom.plpPaginator.innerHTML = html.querySelector(`[${qs.plpPaginator}]`).innerHTML

      const openedFilterIndexes = []
      dom.facetsContainer.querySelectorAll('details[open]').forEach((detail) => {
        openedFilterIndexes.push(parseInt(detail.dataset.index))
      })
      dom.filterSortContainer.innerHTML = html.querySelector(`[${qs.filterSortContainer}]`).innerHTML
      dom.plpTypesFilter.innerHTML = html.querySelector(`[${qs.plpTypesFilter}]`).innerHTML
      if(dom.count) dom.count.innerHTML = html.querySelector(`[${qs.count}]`).innerHTML

      cacheDom(dom, qs, qsAll)
      window.setupProductTiles(document.querySelectorAll('[product-tile="false"]'))
      initFilterFacets(openedFilterIndexes)
      setupPaginations()
      if(location.pathname != dom.productsGrid.dataset.productsGrid) history.pushState({}, "", dom.productsGrid.dataset.productsGrid)
    })
}

const renderFilterResults = () => {
  const selectedFacets = dom.facets.filter((facet) => facet.checked).map((facet) => encodeURI(`${facet.name}=${facet.value}`)).join('&')
  const filterUrl = `${dom.productsGrid.dataset.productsGrid}?section_id=${dom.facetsContainer.dataset.sectionId}&${selectedFacets}&sort_by=${document.querySelector('[name="sort_by"]:checked') && document.querySelector('[name="sort_by"]:checked').value}`
  fetchResults(filterUrl)
}

export const setupCollection = () => {
  if(document.body.classList.contains('template-collection')) {
    cacheDom(dom, qs, qsAll)
    
    dom.filterBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      e.target.classList.toggle('!underline')
      dom.sortBtn.classList.remove('!underline')
      dom.sortContainer.classList.remove('!block')
      state.sortOpened = false
      if(e.target.classList.contains('!underline')) {
        openFilterSort()
        dom.filterContainer.classList.add('!flex')
        state.filterOpened = true
      } else {
        closeFilterSort()
        state.filterOpened = false
      }
    })
  
    dom.sortBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      e.target.classList.toggle('!underline')
      dom.filterBtn.classList.remove('!underline')
      dom.filterContainer.classList.remove('!flex')
      state.filterOpened = false
      if(e.target.classList.contains('!underline')) {
        openFilterSort()
        dom.sortContainer.classList.add('!block')
        state.sortOpened = true
      } else {
        closeFilterSort()
        state.sortOpened = false
      }
    })

    dom.filterSortContainer.addEventListener('click', (e) => {
      if(window.innerWidth >= 1024) e.stopPropagation()
    })
    dom.sortContainer.addEventListener('click', (e) => {
      e.stopPropagation()
    })
    dom.filterContainer.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  
    document.body.addEventListener('click', () => {
      dom.sortBtn.classList.remove('!underline')
      dom.sortContainer.classList.remove('!block')
      dom.filterBtn.classList.remove('!underline')
      dom.filterContainer.classList.remove('!flex')
  
      closeFilterSort()
    })
  
    initFilterFacets()
  }
}